import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbProgressbar } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { DEFAULT_PROGRESS_BAR_CONFIG, ProgressBarConfig } from './progress-bar.modal';

@Component({
  selector: 'ds-progress-bar',
  templateUrl: './progress-bar.component.html',
  standalone: true,
  imports: [NgbProgressbar,CommonModule ]
})
export class ProgressBarComponent {
    @Input() progressBarInput: ProgressBarConfig = { ...DEFAULT_PROGRESS_BAR_CONFIG };
}
